module.exports = "<div class=\"row home\" [ngSwitch]=\"isAuthenticated()\">\n\n    <div class=\"col-md-9\" *ngSwitchCase=\"false\">\n        <h1 class=\"display-4\" jhiTranslate=\"home.title\">Welcome, Java Hipster!</h1>\n        <!--<p class=\"lead\" jhiTranslate=\"home.subtitle\">This is your homepage</p>-->\n    </div>\n    <div class=\"col-md-9\" *ngSwitchCase=\"true\">\n        <dcs-seller-dashboard *dcsHasAnyAuthority=\"'ROLE_SELLER'\"></dcs-seller-dashboard>\n\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/home/home.component.html
// module id = 313
// module chunks = 0